<template>
  <div id="vditor"></div>
  <jw-textarea
    v-if="initializationAfter"
    :placeholder="$t('请填写跟进详情')"
    v-model="content"
    :auto-size="{
      minRows: 2,
      maxRows: 5
    }"
    :style="{ width: '320px' }"
    @blur="textareaVali"
  />
</template>
<script>
import Vditor from 'vditor';
import 'vditor/dist/index.css';
import 'vditor/dist/js/i18n/zh_CN.js';
import { getToken } from '@/utils/auth';
import { Message } from '@arco-design/web-vue';

export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      required: false,
      default() {
        return 'markdown-editor-' + +new Date() + ((Math.random() * 1000).toFixed(0) + '');
      }
    },
    isHideTools: {
      type: Boolean,
      required: false,
      default: false
    },
    isPin: {
      type: Boolean,
      required: false,
      default: true
    },
    height: {
      type: String,
      required: false,
      default: '200px'
    },
    width: {
      type: String,
      required: false,
      default: '320px'
    },
    mode: {
      type: String,
      required: false,
      default: 'wysiwyg'
    }
  },

  data() {
    return {
      contentEditor: '',
      initializationAfter: true,
      content: '',
      token: getToken() || null
    };
  },

  mounted() {
    console.log(55, 11, this.value);
    if (this.value) {
      this.content = this.value;
    }
    this.init();
  },
  methods: {
    textareaVali() {
      this.$emit('blurEvent', this.content);
    },
    init() {
      console.log(83, this.token);
      this.contentEditor = new Vditor('vditor', {
        height: this.height,
        width: this.width,
        toolbarConfig: {
          pin: this.isPin,
          hide: this.isHideTools
        },
        i18n: window.VditorI18n || {},
        toolbar: [
          'emoji',
          'headings',
          'bold',
          'italic',
          'list',
          'ordered-list',
          {
            name: 'upload',
            tipPosition: 's',
            tip: '上传图片',
            className: 'right'
          },
          'undo',
          'redo',
          '|',
          'fullscreen'
        ],
        after: async () => {
          console.log(81, '初始化完成');
          this.initializationAfter = false;
          this.contentEditor.setValue(this?.content || this.value);
          console.log(81, this.initializationAfter, this.contentEditor);
        },
        blur: async (value) => {
          // const v = await Vditor.md2html(value);
          // console.log(392, '----', value, v);
          this.$emit('blurEvent', value);
        },
        hint: {
          parse: true
        },
        mode: this.mode,
        preview: {
          mode: 'ev', //'both'
          actions: []
        },
        // classes: 'preview-image',
        image: {
          isPreview: false
          // preview: (element) => {
          //   console.log(130, element);
          // }
        },
        upload: {
          accept: 'image/*', // 规定上传的图片格式
          url: '/api/uploadImage', // 请求的接口
          multiple: true,
          fieldName: 'file',
          max: 10 * 1024 * 1024, //上传图片的大小
          headers: {
            authorization: `Bearer ${this.token}`
          },
          linkToImgUrl: '/api/uploadImage', //剪切板中包含图片地址时，使用此 url 重新上传
          validate(files) {
            //校验，成功时返回 true 否则返回错误信息
            console.log(140, files);
            const isLessThan10M = files[0].size / 1024 / 1024 < 10;
            if (!isLessThan10M) {
              Message.error('上传图片最大不能超过 10MB!');
            }
          },
          file: (files) => {
            console.log(153, files);
            if (files.length > 10) {
              files.length = 10;
              Message.warning('单次上传最对可成功前10张图片');
            }
            return files;
          },
          // 上传图片回显处理
          format(files, responseText) {
            var data = JSON.parse(responseText);
            console.log(156, files, responseText, data);
            // 上传图片请求状态
            if (data.code == 0) {
              const filName = data.data;
              const succ = {};
              filName?.forEach((item) => {
                const lastTipNum = item.split('/');
                const n = lastTipNum[lastTipNum.length - 1];
                console.log(154, lastTipNum, n);
                succ[n] = location.protocol + item;
              });
              console.log(155, succ);
              //图片回显
              return JSON.stringify({
                data: {
                  errFiles: [],
                  succMap: succ
                }
              });
            } else {
              Message.error('图片上传失败');
            }
          },
          error(msg) {
            console.log(msg + '上传失败');
          }
        }
      });
    },

    getValue() {
      return this.contentEditor.getValue(); //获取 Markdown 内容
    },
    getHTML() {
      return this.contentEditor.getHTML(); //获取 HTML 内容
    },
    setValue(value) {
      this.contentEditor.setValue(value); //设置 Markdown 内容
    },
    disabled() {
      return this.contentEditor.disabled(); //设置 只读
    },
    html2md(v) {
      return this.contentEditor.html2md(v); //设置 只读
    },
    toPreview() {
      var evt = document.createEvent('Event');
      evt.initEvent('click', true, true);
      this.contentEditor.vditor.toolbar.elements.preview.firstElementChild.dispatchEvent(evt);
    },
    destroy() {
      if (!this.initializationAfter) this.contentEditor && this.contentEditor?.destroy?.();
    }
  },

  beforeUnmount() {
    this.destroy();
  }
};
</script>
<style scoped lang="less">
@import './markdown.less';
</style>
